import { GoToEvents } from '../types';

export function keyToEvent<TKeys extends string>(
  key: TKeys,
): GoToEvents<TKeys> {
  return `GO_TO_${key.toUpperCase()}` as GoToEvents<TKeys>;
}
